export default "__VITE_ASSET__09bc225c__"